import React from 'react';
import { DndContext, DragEndEvent, closestCenter, UniqueIdentifier } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

export interface DragEndEventWithRowData extends DragEndEvent {
  activeRowData?: any;
  overRowData?: any;
  allRowsData?: any[];
  mainRows?: any[];
}

interface DragDropWrapperProps {
  children: React.ReactNode;
  onDragEnd?: (event: DragEndEventWithRowData) => void;
  items?: UniqueIdentifier[];
  allRowsData?: any[];
  mainRows?: any[];
}

const DragDropWrapper: React.FC<DragDropWrapperProps> = ({ 
  children, 
  onDragEnd, 
  items = [],
  allRowsData = [],
  mainRows = []
}) => {
  // If onDragEnd is not provided, render children without drag and drop functionality
  if (!onDragEnd) {
    return <>{children}</>;
  }

  const handleDragEnd = (event: DragEndEvent) => {
    // Find the row data for the active and over items
    const activeRowData = mainRows.find(row => row.id === event.active.id);
    const overRowData = mainRows.find(row => row.id === event.over?.id);

    // Create enhanced event with row data
    const enhancedEvent: DragEndEventWithRowData = {
      ...event,
      activeRowData,
      overRowData,
      allRowsData
    };

    onDragEnd(enhancedEvent);
  };

  // If onDragEnd is provided, wrap children with DndContext and SortableContext
  return (
    <DndContext
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={items}
        strategy={verticalListSortingStrategy}
      >
        {children}
      </SortableContext>
    </DndContext>
  );
};

export default DragDropWrapper;